export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const RAZORPAY_URL = process.env.REACT_APP_RAZORPAY_URL;

export const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;